(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('moodtwist-footer-map')) {
    customElements.define('moodtwist-footer-map', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const load = this.querySelector('[data-map-load]');
        const close = this.querySelector('[data-map-close]');
        const placeholder = this.querySelector('.mt-footer-map__placeholder');
        const frameHost = this.querySelector('.mt-footer-map__frame');
        const source = this.dataset.mapSrc;
        if (!load || !close || !placeholder || !frameHost || !source) return;
        let url;
        try { url = new URL(source); } catch { return; }
        if (url.origin !== 'https://www.google.com' || url.pathname !== '/maps/embed') return;
        load.hidden = false;
        load.addEventListener('click', () => {
          if (frameHost.firstElementChild) return;
          const iframe = document.createElement('iframe');
          iframe.title = this.dataset.mapTitle;
          iframe.width = '600';
          iframe.height = '450';
          iframe.loading = 'eager';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.allowFullscreen = true;
          iframe.src = source;
          frameHost.append(iframe);
          frameHost.hidden = false;
          placeholder.hidden = true;
          load.setAttribute('aria-expanded', 'true');
          close.hidden = false;
          close.focus({preventScroll: true});
        });
        close.addEventListener('click', () => {
          frameHost.replaceChildren();
          frameHost.hidden = true;
          placeholder.hidden = false;
          load.setAttribute('aria-expanded', 'false');
          close.hidden = true;
          load.focus({preventScroll: true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moodtwist-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moodtwist-review-story')) {
    customElements.define('moodtwist-review-story', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.carousel = this.querySelector('scroll-carousel');
        this.toggle = this.querySelector('[data-review-toggle]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.45; this.schedule(); }, { threshold: 0.45 });
        this.observer.observe(this);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
        this.addEventListener('pointerdown', event => { if (!event.target.closest('[data-review-toggle]')) { this.paused = true; this.updateToggle(); this.schedule(); } }, { signal });
        this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.updateToggle(); this.schedule(); }, { signal });
        customElements.whenDefined('scroll-carousel').then(() => { if (this.isConnected) this.schedule(); });
        this.updateToggle();
      }
      updateToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.querySelector('[data-review-toggle-label]').textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.hasAttribute('auto-rotate') || this.paused || this.reduced.matches || !this.visible || this.hovered || this.focused || document.hidden || typeof this.carousel?.select !== 'function') return;
        this.timer = setTimeout(() => {
          const count = this.carousel.children.length;
          if (count > 1) this.carousel.select((this.carousel.selectedIndex + 1) % count);
          this.schedule();
        }, 9000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
